import { FC } from 'react';

import { useNavigation } from '@atom/hooks/useNavigation';

import InventoryDetail from './InventoryDetail';

const InventoryDetailClassWrapper: FC = () => {
  const [
    searchParamsObject,
    { backDestination, navigate, params, updateSearchParams },
  ] = useNavigation();
  const { id } = params;
  return (
    <InventoryDetail
      id={id}
      navigate={navigate}
      searchParamsObject={searchParamsObject}
      updateSearchParams={updateSearchParams}
      backDestination={backDestination}
    />
  );
};

export default InventoryDetailClassWrapper;
